import {SalesDespatchItemProcessingReport} from "./sales-despatch-item-processing-report";

export interface SalesInvoiceItemReport {
  salesOrderAndLineNo: string;
  customerLineRef: string;
  quantity: number;
  price: number;
  value: number;
  notes: string;
  orderPrice: number;
  commission: number;
  currencySymbol: string;
  unitOfMeasure: string;

  salesDespatchItemProcessings: SalesDespatchItemProcessingReport[];
}
